import User, { UserSettings } from "./User";
import ClinicService from "./services/ClinicService";
import AccountService from "./services/AccountService";

const account = new AccountService();

export default class Doctor extends User{
    constructor(json, clinicId){
        super(json);
        this.settings = new DoctorSettings(this.userId,  clinicId || account.clinicId);// UserSettings(ClinicService.GetCachePath(clinicId) + '/Doctor/' + this.userId);
    }
}

export class DoctorSettings extends UserSettings{
    constructor(id, clinicId){
        super(ClinicService.GetCachePath(clinicId) + '/Doctor' , (id || account.userId));
    }
}



// WEBPACK FOOTER //
// ./src/api/Doctor.js